import { render, staticRenderFns } from "./OfficeAction.vue?vue&type=template&id=61de797a&"
import script from "./OfficeAction.vue?vue&type=script&lang=js&"
export * from "./OfficeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports